<template>
  <div class="promotionGood" v-if="benefit.length > 0">
    <div @click="goRouter(item.id)" class="item acea-row row-between-wrapper" v-for="(item, index) in benefit"
      :key="index">
      <!-- @click="goRouter(item.id)" -->
      <div class="pictrue">
        <img :src="item.image" class="image" />
        <!-- 显示标识符根据startTag属性 -->
        <div v-if="item.startTag == 1" class="top-badge">
          <img src="@/assets/images/Top1.png" class="badge-img" />
        </div>
      </div>
      <div class="text">
        <div class="acea-row row-middle">
          <div class="name" style="flex: 1">{{ item.realName }}</div>
          <div class="acea-row row-middle" v-if="$store.state.app.isFirst < $store.state.app.firstNumber &&
           item.firstReservation != 0 && !$store.state.app.productIds.includes(Number(item.id))
    ">
            <div class="first-price">
              首单:￥{{ $store.state.app.dictObj.first_price }}
            </div>
            <div class="price">￥{{ item.price }}</div>
          </div>
          <div class="first-price" v-else>￥{{ item.price }}</div>
        </div>
        <div class="sp-message">
          {{ item.storeInfo }}
        </div>
        <div class="acea-row row-between-wrapper sp-tag">
          <div class="acea-row row-middle">
            <img src="@assets/img/icon_yj.png" />
            <span>约见{{ item.sales }}次</span>
          </div>
          <div class="acea-row row-middle">
            <img src="@assets/img/icon_ad.png" />
            <span>{{
    $store.state.app.addressObject
      ? cityText(item.provinceCode, item.cityCode)
      : ""
  }}</span>
          </div>
          <div class="acea-row row-middle">
            <img src="@assets/img/icon_xx.png" />
            <span>{{
      $store.state.app.dictObj.meet_type
        ? meetTypeText(item.meetType)
        : ""
    }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PromotionGood",
  props: {
    benefit: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {};
  },
  methods: {
    meetTypeText(meetType) {
      if (!meetType) return ''
      return meetType
        .split(",")
        .map((item) => this.$store.state.app.dictObj.meet_type[item])
        .join("/");
    },
    cityText(provinceCode, cityCode) {
      return this.$store.state.app.addressObject[provinceCode]
        ? this.$store.state.app.addressObject[provinceCode][cityCode]
        : "";
    },
    goRouter(id) {
      this.$router.push({
        path: "/detail/" + id,
      });
      
    },
  },
};
</script>
<style scoped>
.promotionGood .item {
  align-items: start;
}

.pictrue {
  position: relative;
}

.top-badge {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

.badge-img {
  width: 0.4rem;
  height: auto;
  transform: translate(0, 0);
}


</style>
